<template>
    <div class="header" style="min-width: 100%;width:auto ;overflow: auto;">
        <!-- ============= 公共组件header背景图 ============= -->
        <div class="header-box" style="width: 1310px;">
            <div class="header-img">
                <img onclick="location.href='homes'" src="../assets/images/login/logo.png" style="cursor: pointer;">
            </div>

            <!-- ============= 菜单部分 ============= -->
            <div class="menus">
                <div class="menus-content">
                    <el-menu class="el-menu-demo"
                             mode="horizontal"
                             active-text-color="#4391ec"
                             @select="handleSelect"
                             :default-active="navigationMenu[0].type_id">
                        <div style="display: inline-block; outline:none;" v-for="(item, index) in navigationMenu" :key="index">
                            <el-menu-item v-if="!item.child"
                                          :index="item.type_id"
                                          class="menu-single">
                                <!--<a :href="host+item.type_url+'?id='+item.type_id">{{item.type_name}}</a>-->
                                <router-link :to="item.type_url"
                                             :class="itemColor">{{item.type_name}}</router-link><!-- 不能使用英文汉字混合 -->
                            </el-menu-item>
                            <el-submenu :index="item.type_id" v-if="item.child">
                                <template slot="title">
                                    {{item.type_name}}
                                </template>
                                <div v-for="(data, dataIndex) in item.child" :key="dataIndex">
                                    <el-menu-item v-if="!data.child" :index="data.type_id">
                                        <el-menu-item v-if="data.type_sign=='out_url'">
                                            <a target="_blank" :href="data.type_url" style="display: inline-block;width: 100%;">{{data.type_name}}</a>
                                        </el-menu-item>
                                        <el-menu-item v-else>
                                            <router-link :to="{path: data.type_url, query: {type_id: data.type_id,a_v_type:1}}" @click.native="flushCom" style="display: inline-block;width: 100%;">{{data.type_name}}</router-link>
                                        </el-menu-item>
                                    </el-menu-item>
                                    <el-submenu v-if="data.child" :index="data.type_id">
                                        <template slot="title">
                                            <el-menu-item v-if="data.type_sign=='out_url'">
                                                <a target="_blank" :href="data.type_url" style="display: inline-block;width: 100%;">{{data.type_name}}</a>
                                            </el-menu-item>
                                            <el-menu-item v-else-if="data.type_url=='#'">
                                                <a href="javascript:void(0)" style="display: inline-block;width: 100%;">{{data.type_name}}</a>
                                            </el-menu-item>
                                            <el-menu-item v-else>
                                                <router-link :to="{path: data.type_url, query: {type_id: data.type_id,a_v_type:1}}" @click.native="flushCom" style="display: inline-block;width: 100%;">{{data.type_name}}</router-link>
                                            </el-menu-item>
                                        </template>
                                        <el-menu-item :index="childs.type_id"
                                                      v-for="(childs,childsIndexs) in data.child"
                                                      :key="childsIndexs">
                                            <el-menu-item v-if="childs.type_sign=='out_url'">
                                                <a target="_blank" :href="childs.type_url" style="display: inline-block;width: 100%;">{{childs.type_name}}</a>
                                            </el-menu-item>
                                            <el-menu-item v-else>
                                                <router-link :to="{path: childs.type_url, query: {type_id: childs.type_id,a_v_type:1}}" @click.native="flushCom" style="display: inline-block;width: 100%;">{{childs.type_name}}</router-link>
                                            </el-menu-item>
                                        </el-menu-item>
                                    </el-submenu>
                                </div>
                            </el-submenu>
                        </div>
                    </el-menu>

                    <!--<el-menu class="el-menu-demo" mode="horizontal" @select="handleSelect" router>-->
                    <!--<el-menu-item index="/home" style="font-size: 24px;color: #303133">首页</el-menu-item>-->

                    <!--<el-submenu index="2">-->
                    <!--<template slot="title">产品</template>-->
                    <!--<el-menu-item index="/product">-->
                    <!--<a style="font-size: 16px;color: rgba(51,51,51,1);margin-left: 10px">资料分类</a>-->
                    <!--</el-menu-item>-->

                    <!--<el-menu-item index="/detaile">-->
                        <!--<a style="font-size: 16px;color: rgba(51,51,51,1);margin-left: 10px">产品详情</a>-->
                        <!--</el-menu-item>-->
                        <!--</el-submenu>-->

                        <!--<el-menu-item index="/tools" style="font-size: 24px;color: rgba(51,51,51,1)">工具与资料-->
                        <!--</el-menu-item>-->

                        <!--<el-submenu index="4">-->
                        <!--<template slot="title">新闻</template>-->
                        <!--<el-menu-item index="/news">-->
                        <!--<a style="font-size: 16px;color: rgba(51,51,51,1);margin-left: 10px">信息更新</a>-->
                        <!--</el-menu-item>-->
                        <!--<el-menu-item index="/article">-->
                        <!--<a style="font-size: 16px;color: rgba(51,51,51,1);margin-left: 10px">知识文章</a>-->
                        <!--</el-menu-item>-->
                        <!--</el-submenu>-->

                        <!--<el-submenu index="5">-->
                        <!--<template slot="title">关于中颖</template>-->
                        <!--<el-menu-item index="/about">-->
                        <!--<a style="font-size: 16px;color: rgba(51,51,51,1);margin-left: 10px">企业简介</a>-->
                        <!--</el-menu-item>-->

                        <!--<el-menu-item index="/event">-->
                        <!--<a style="font-size: 16px;color: rgba(51,51,51,1);margin-left: 10px">中颖大记事</a>-->
                        <!--</el-menu-item>-->

                        <!--<el-menu-item index="/dealer">-->
                        <!--<a style="font-size: 16px;color: rgba(51,51,51,1);margin-left: 10px">经销商信息</a>-->
                        <!--</el-menu-item>-->

                        <!--<el-menu-item index="/jobs">-->
                        <!--<a style="font-size: 16px;color: rgba(51,51,51,1);margin-left: 10px">中颖招聘</a>-->
                        <!--</el-menu-item>-->

                        <!--<el-menu-item index="/post">-->
                        <!--<a style="font-size: 16px;color: rgba(51,51,51,1);margin-left: 10px">招聘详情</a>-->
                        <!--</el-menu-item>-->

                        <!--<el-menu-item index="/contact">-->
                        <!--<a style="font-size: 16px;color: rgba(51,51,51,1);margin-left: 10px">联系我们</a>-->
                        <!--</el-menu-item>-->
                        <!--</el-submenu>-->

                        <!--<el-menu-item index="/partner" style="font-size: 24px;color: rgba(51,51,51,1);">投资者关系-->
                        <!--</el-menu-item>-->
                    <!--</el-menu>-->
                </div>

                <div class="header-login-register" style="width: 380px;">
                    <ul>
                        <li style="display: inline">
                            <el-input v-model="all_search" list="all_pro_name" class="menus-search" placeholder="请输入内容" style="width: 240px;" @change="change_all_search" onfocus="this.style.textTransform='uppercase'">
                                <!--el-select></el-select-->
                                <el-button slot="append" icon="el-icon-search" size="small" @click="seach_go"></el-button>
                            </el-input>
                        </li>

                        <li style="display: inline">
                            <!--a href="/login" style="font-size: 16px;color: #4A90E2">登录</a>
                            <span style="color: #4A90E2;">|</span>
                            <a href="/register" style="font-size: 16px;margin-left: 0;color: #4A90E2">注册</a-->
                            <a target="_blank" href="https://en.sinowealth.com" style="font-size: 16px;margin-left: 0;color: #4A90E2">EN</a>|
                            <a target="_blank" href="https://ja.sinowealth.com" style="font-size: 16px;margin-left: 0;color: #4A90E2">JA</a>
                        </li>
                    </ul>
                   
                </div>
                <datalist id="all_pro_name">
                    <option
                            v-for="item in pro_all_name"
                            :key="item"
                    >{{item}}</option>
                </datalist>
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>


<script>
  export default {
    name: "header",
    data() {
        return {
            itemColor:'homesColor',
            navigationMenu: [], // 导航菜单
            all_search:'',
            pro_all_name: [],
        }
    },
    mounted: function () {
        this.getMenu(); // 获取菜单
        this.all_search=this.get_get_val('search');
     },
    methods: {
        getMenu () { // 获取菜单
                let vm = this;
                this.$axios({
                        method:'get',
                        url:'/api/pre/json_go/look_one?type=3',
                    }).then((response) =>{          //这里使用了ES6的语法
                        this.navigationMenu = response.data.men;
                        this.pro_all_name = response.data.pro_all_name;
                    }).catch((error) =>
                        console.log(error)       //请求失败返回的数据
                    )
                },
        handleSelect(key, keyPath) {
            let vm = this;
            if (key===vm.navigationMenu[0].type_id){
                vm.itemColor = 'homesColor';
            }else {
                vm.itemColor = '';
            }
        },
        flushCom:function(){
            //router是路由实例,例如:var router = new Router({})
            //router.go(n)是路由的一个方法，意思是在history记录中前进或者后退多少步，0就表示还是当前，类似window.history.go(n)
            this.$router.go(0);
        },
        change_all_search:function(inpVal){
            this.all_search = inpVal;
        },
        seach_go:function(){
            location.href = '/seach?search='+this.all_search;
        },
        get_get_val:function (get_name){
                // 获取参数type_id的值
                var reg = new RegExp("(^|&)" + get_name + "=([^&]*)(&|$)");
                var r = window.location.search.substr(1).match(reg);
                if (r != null){
                    return decodeURI(r[2]);
                }else{
                    return '';
                }
            }
    },
    created:function(){
        let _this = this;
        document.onkeydown = function(e){
        let _key = window.event.keyCode;
            if(_key === 13){
                //_this.seach_go();
            }
        }
    },
  }
  
  window.onscroll=function(){
  var sl=-Math.max(document.body.scrollLeft,document.documentElement.scrollLeft);
  //$('.header').animate({ scrollLeft:sl+'px'}, 10);
  document.getElementsByClassName('header')[0].style.left=sl+'px';
};
</script>

<style>
  .header { background-color: #ffffff;;height: 107px !important;text-align: center;position: fixed;top: 0;z-index: 100;}
  .header-box {width: 1300px;height: 103px;display: inline-block;}
  .header-box .header-img {width: 100px;height: 76px;padding-top: 15px;display: inline-block;float: left;}
  .header-box .menus {min-width: 1080px;display: inline-block;}
  .menus-content .el-submenu__icon-arrow {right: 0;font-size: 16px;}
  .menus-content .el-submenu__title {font-size: 24px;}
  .el-menu--horizontal a {font-size: 15px;color: #333333;}
  .el-menu-demo .menu-single {font-size: 24px;color: #303133;}

  /*.header .menus  { list-style:none;text-align: center;padding-top: 20px }*/
  /*.header > ul > li > a {  font-size: 24px;color: #333333;margin-left: 40px;cursor: pointer}*/
  /*.header .menus > li  {  position: relative;vertical-align: top;display: inline;width:120px;height:88px}*/
  /*.header .login-register > a { text-decoration: none;font-size: 12px;color: #4A90E2; }*/
  /*.header li { width: 72px }*/
  /*.header >* { display: inline-block;line-height: 80px;vertical-align: middle }*/
  .header .el-menu-demo a { font-size: 24px;color: rgba(51,51,51,1); }
  .header .el-menu--horizontal>.el-submenu .el-submenu__title { font-size: 24px;color: rgba(51,51,51,1); }
  .header .menus .sub-menu > a { font-size: 16px;color: rgba(51,51,51,1); margin-left: 10px}
  .header .menus .menus-content {padding-top: 20px;margin-left: 60px;float: left }
  .header .menus .header-login-register {padding-top: 22px;display: table-cell;margin-left: 20px;width: 360px;float: right }
  .header .el-menu--horizontal>.el-menu-item { color: #333;font-size: 24px }
  .header .el-input__inner { height: 35px }
  .header .el-menu-item  { padding: 0 10px; }
  .header .el-menu-demo el-menu--horizontal el-menu { width: 670px }
  .header .menus-content > li { width: 120px }
  .clear { clear: both  }
  .homesColor {color: #4391ec !important;}
</style>



// WEBPACK FOOTER //
// src/components/header.vue